import { AnimatePresence, motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function ModalCitasConfig({
  isModalOpen,
  setIsModalOpen,
  tiempoCitas,
  setTiempoCitas,
  duracionCitas,
  setDuracionCitas,
  maximoCitas,
  setMaximoCitas,
  maximoTiempoAnticipacion,
  setMaximoTiempoAnticipacion,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsModalOpen(false); 
  };

  

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          key="modal-background"
          onClick={() => setIsModalOpen(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-lg shadow-lg p-6 font-poppina w-[500px] mx-4 border border-gray-100"
          >
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-semibold text-text">
                Configuración de Citas
              </h3>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-text mb-1">
                  Tiempo de cita (minutos)
                </label>
                <input
                  type="number"
                  value={tiempoCitas}
                  onChange={(e) => setTiempoCitas(e.target.value)}
                  className="w-full p-2 border border-border rounded-md"
                  placeholder="Ej: 30"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-1">
                  Tiempo entre citas (minutos)
                </label>
                <input
                  type="number"
                  value={duracionCitas}
                  onChange={(e) => setDuracionCitas(e.target.value)}
                  className="w-full p-2 border border-border rounded-md"
                  placeholder="Ej: 15"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-1">
                  Máximo de citas por día
                </label>
                <input
                  type="number"
                  value={maximoCitas}
                  onChange={(e) => setMaximoCitas(e.target.value)}
                  className="w-full p-2 border border-border rounded-md"
                  placeholder="Ej: 10"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-1">
                  Máximo de tiempo de anticipación (días)
                </label>
                <input
                  type="number"
                  value={maximoTiempoAnticipacion}
                  onChange={(e) => setMaximoTiempoAnticipacion(e.target.value)}
                  className="w-full p-2 border border-border rounded-md"
                  placeholder="Ej: 7"
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition-colors"
              >
                Guardar Configuración
              </button>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}